import { Route } from "react-router";

import { HotelIDLayout } from "@/components/layouts/hotel-id-page-layout";

import { HotelIDRootErrorBoundary } from "@/components/features/error-boundary";

import { DesignHPBListPage } from "@/components/pages/[hotelID]/HPB/list/page";
import { CancellationPage } from "@/components/pages/[hotelID]/cancellation/page";
import { ContactChatRoomPage } from "@/components/pages/[hotelID]/contact/chat-room/page";
import { ContactNewPage } from "@/components/pages/[hotelID]/contact/new/page";
import { ContactTopPage } from "@/components/pages/[hotelID]/contact/top/page";
import { FAQDetailPage } from "@/components/pages/[hotelID]/faq/[notionId]/page";
import { FAQPage } from "@/components/pages/[hotelID]/faq/page";
import { CustomMailSettingI18nPage } from "@/components/pages/[hotelID]/hotelSettings/custom-mail-setting/[i18n]/page";
import { CustomMailSettingDefaultPage } from "@/components/pages/[hotelID]/hotelSettings/custom-mail-setting/default/page";
import { HotelSettingsEmailPage } from "@/components/pages/[hotelID]/hotelSettings/email/page";
import { HotelInfoEditI18nPage } from "@/components/pages/[hotelID]/hotelSettings/hotel-info/[i18n]/page";
import { HotelInfoEditDefaultPage } from "@/components/pages/[hotelID]/hotelSettings/hotel-info/default/page";
import { HotelPolicyEditPageI18n } from "@/components/pages/[hotelID]/hotelSettings/hotelPolicy/[i18n]/page";
import { HotelPolicyEditPageDefault } from "@/components/pages/[hotelID]/hotelSettings/hotelPolicy/default/page";
import { InvoiceSystemSettingsPage } from "@/components/pages/[hotelID]/invoice-system/settings/page";
import { DiscountDuplicatePage } from "@/components/pages/[hotelID]/items/discount/duplicate/page";
import { DiscountEditPage } from "@/components/pages/[hotelID]/items/discount/edit/page";
import { DiscountListPage } from "@/components/pages/[hotelID]/items/discount/list/page";
import { DiscountNewPage } from "@/components/pages/[hotelID]/items/discount/new/page";
import { OptionEditPageI18n } from "@/components/pages/[hotelID]/items/option/edit/[optionID]/[i18n]/page";
import { OptionEditPageDefault } from "@/components/pages/[hotelID]/items/option/edit/[optionID]/default/page";
import { NewOptionEditPageDefault } from "@/components/pages/[hotelID]/items/option/edit/new/default/page";
import { OptionListPage } from "@/components/pages/[hotelID]/items/option/list/page";
import { OptionStockPage } from "@/components/pages/[hotelID]/items/option/stock/page";
import { OptionStockDeprecatedPage } from "@/components/pages/[hotelID]/items/option/stock-deprecated/page";
import { PlanI18nEditPage } from "@/components/pages/[hotelID]/items/plan/edit/[planID]/[i18n]/page";
import { ExistingDayTripPlanI18nEditPage } from "@/components/pages/[hotelID]/items/plan/edit/[planID]/dayTrip/[i18n]/page";
import { ExistingDayTripPlanEditPage } from "@/components/pages/[hotelID]/items/plan/edit/[planID]/dayTrip/default/page";
import { PlanEditPage } from "@/components/pages/[hotelID]/items/plan/edit/[planID]/default/page";
import { NewDayTripPlanEditPageDefault } from "@/components/pages/[hotelID]/items/plan/edit/new/dayTrip/page";
import { NewPlanEditPageDefault } from "@/components/pages/[hotelID]/items/plan/edit/new/page";
import { PlanListPage } from "@/components/pages/[hotelID]/items/plan/list/page";
import { PlanRateMatrixPage } from "@/components/pages/[hotelID]/items/plan/rate-matrix/page";
import { PlanStockPage } from "@/components/pages/[hotelID]/items/plan/stock/page";
import { PlanStockDeprecatedPage } from "@/components/pages/[hotelID]/items/plan/stock-deprecated/page";
import { RoomEditPageI18n } from "@/components/pages/[hotelID]/items/room/edit/[roomID]/[i18n]/page";
import { RoomEditPageDefault } from "@/components/pages/[hotelID]/items/room/edit/[roomID]/default/page";
import { DummyRoomEditPage } from "@/components/pages/[hotelID]/items/room/edit/[roomID]/dummy/page";
import { NewRoomDefaultEditPage } from "@/components/pages/[hotelID]/items/room/edit/new/default/page";
import { NewDummyRoomEditPage } from "@/components/pages/[hotelID]/items/room/edit/new/dummy/page";
import { RoomListPage } from "@/components/pages/[hotelID]/items/room/list/page";
import { RoomPriceRankPage } from "@/components/pages/[hotelID]/items/room/price-rank/page";
import { RoomPriceRankDeprecatedPage } from "@/components/pages/[hotelID]/items/room/price-rank-deprecated/page";
import { RoomStockPage } from "@/components/pages/[hotelID]/items/room/stock/page";
import { RoomStockDeprecatedPage } from "@/components/pages/[hotelID]/items/room/stock-deprecated/page";
import { ManagementActivitiesOptionsPage } from "@/components/pages/[hotelID]/management";
import { ManagementECReceiptDetailPage } from "@/components/pages/[hotelID]/management/ec-sales/detail/page";
import { ManagementECSalecTopPage } from "@/components/pages/[hotelID]/management/ec-sales/top/page";
import { ManagementRefundRequestTopPage } from "@/components/pages/[hotelID]/management/refund-request/top/page";
import { ManagementReservationEditPage } from "@/components/pages/[hotelID]/management/reservation/[reservationID]/editReservation/page";
import { ManagementReservationAddPage } from "@/components/pages/[hotelID]/management/reservation/addReservation/page";
import { ManagementReservationCalendarPage } from "@/components/pages/[hotelID]/management/reservation/calendar/page";
import { ManagementReservationDetailPage } from "@/components/pages/[hotelID]/management/reservation/detail/page";
import { ManagementReservationRequestListPage } from "@/components/pages/[hotelID]/management/reservation/request-list/page";
import { ManagementReservationTopPage } from "@/components/pages/[hotelID]/management/reservation/top/page";
import { ManagementSalesReceiptsPage } from "@/components/pages/[hotelID]/management/sales/receipts/page";
import { ManagementSalesTopPage } from "@/components/pages/[hotelID]/management/sales/top/page";
import { MarketingCampaignDetailsPage } from "@/components/pages/[hotelID]/marketing/campaign/details/page";
import { MarketingCampaignEditPage } from "@/components/pages/[hotelID]/marketing/campaign/edit/page";
import { MarketingCampaignCreateNewCampaignPage } from "@/components/pages/[hotelID]/marketing/campaign/new/page";
import { MarketingCampaignTopPage } from "@/components/pages/[hotelID]/marketing/campaign/top/page";
import { MarketingVoucherI18nEditPage } from "@/components/pages/[hotelID]/marketing/voucher/edit/[voucherID]/[i18n]/page";
import { MarketingVoucherEditPage } from "@/components/pages/[hotelID]/marketing/voucher/edit/[voucherID]/default/page";
import { MarketingNewVoucherEditPage } from "@/components/pages/[hotelID]/marketing/voucher/edit/new/page";
import { MarketingVoucherTopPage } from "@/components/pages/[hotelID]/marketing/voucher/top/page";
import { HotelTopPage } from "@/components/pages/[hotelID]/page";
import { DesignPlainDefaultPage } from "@/components/pages/[hotelID]/reservationPage/base/page";
import { DesignMagazineAboutHotelListPage } from "@/components/pages/[hotelID]/reservationPage/magazine/list/hotel/page";
import { DesignMagazinePlanListPage } from "@/components/pages/[hotelID]/reservationPage/magazine/list/plan/page";
import { DesignMagazineRoomListPage } from "@/components/pages/[hotelID]/reservationPage/magazine/list/room/page";
import { DesignMagazineSettingPage } from "@/components/pages/[hotelID]/reservationPage/magazine/setting/page";
import { DesignSnackListPage } from "@/components/pages/[hotelID]/reservationPage/snack/list/page";
import { DesignSnackSettingPage } from "@/components/pages/[hotelID]/reservationPage/snack/settings/page";
import { SettingsBillingPage } from "@/components/pages/[hotelID]/settings/billing/page";
import { SettingsPaymentCreditPage } from "@/components/pages/[hotelID]/settings/payment-credit/page";
import { SettingsPaymentDepositAccountPage } from "@/components/pages/[hotelID]/settings/payment-deposit-account/page";
import { SettingsSecurityPage } from "@/components/pages/[hotelID]/settings/security/page";
import { SettingsSiteControllerPage } from "@/components/pages/[hotelID]/settings/site-controller/page";
import { SettingsExternalConnectionGoogleFreeBookingLinksPage } from "@/components/pages/[hotelID]/settings-external-connection";
import { SettingsExternalConnectionGoogleFreeBookingLinksI18nPage } from "@/components/pages/[hotelID]/settings-external-connection/google-free-booking-links-i18n/page";
import { SettingsExternalConnectionSiteEmbedPage } from "@/components/pages/[hotelID]/settings-external-connection/site-embed/page";
import { StartGuideChecklistPage } from "@/components/pages/[hotelID]/start-guide-checklist/page";

import { PATHS } from "../paths";

export const HotelRouteWithLayout = (
	<Route element={<HotelIDLayout />} errorElement={<HotelIDRootErrorBoundary />}>
		<Route path={PATHS.HOTEL.TOP} index element={<HotelTopPage />} />

		{/* インボイス設定 */}
		<Route path={PATHS.HOTEL.INVOICE_SYSTEM.SETTINGS} index element={<InvoiceSystemSettingsPage />} />

		{/* マーケティング */}
		{/* キャンペーン */}
		{/* キャンペーントップ（一覧） */}
		<Route path={PATHS.HOTEL.MARKETING.CAMPAIGN.TOP} index element={<MarketingCampaignTopPage />} />
		{/* キャンペーン新規作成 */}
		<Route path={PATHS.HOTEL.MARKETING.CAMPAIGN.NEW} index element={<MarketingCampaignCreateNewCampaignPage />} />
		{/* キャンペーン編集 */}
		<Route path={PATHS.HOTEL.MARKETING.CAMPAIGN.EDIT} index element={<MarketingCampaignEditPage />} />
		{/* キャンペーン詳細 */}
		<Route path={PATHS.HOTEL.MARKETING.CAMPAIGN.DETAILS} index element={<MarketingCampaignDetailsPage />} />

		{/* 宿泊券 */}
		{/* 宿泊券トップ（一覧） */}
		<Route path={PATHS.HOTEL.MARKETING.VOUCHER.TOP} index element={<MarketingVoucherTopPage />} />
		{/* 宿泊券編集 */}
		<Route path={PATHS.HOTEL.MARKETING.VOUCHER.EDIT} index element={<MarketingVoucherEditPage />} />
		{/* 宿泊券編集 I18n */}
		<Route path={PATHS.HOTEL.MARKETING.VOUCHER.I18N} index element={<MarketingVoucherI18nEditPage />} />
		{/* 宿泊券新規作成 */}
		<Route path={PATHS.HOTEL.MARKETING.VOUCHER.NEW} index element={<MarketingNewVoucherEditPage />} />

		{/* 顧客管理 */}
		{/* 予約管理 */}
		{/* 予約 TOP */}
		<Route path={PATHS.HOTEL.MANAGEMENT.RESERVATION.TOP} index element={<ManagementReservationTopPage />} />
		<Route path={PATHS.HOTEL.MANAGEMENT.RESERVATION.ADD} index element={<ManagementReservationAddPage />} />
		{/* カレンダー */}
		<Route
			path={PATHS.HOTEL.MANAGEMENT.RESERVATION.CALENDAR}
			index
			element={<ManagementReservationCalendarPage />}
		/>
		{/* 新着リクエスト */}
		<Route
			path={PATHS.HOTEL.MANAGEMENT.RESERVATION.REQUEST_LIST}
			index
			element={<ManagementReservationRequestListPage />}
		/>
		{/* 予約詳細 */}
		<Route path={PATHS.HOTEL.MANAGEMENT.RESERVATION.DETAIL} index element={<ManagementReservationDetailPage />} />
		{/* 予約編集 */}
		<Route path={PATHS.HOTEL.MANAGEMENT.RESERVATION.EDIT} index element={<ManagementReservationEditPage />} />
		{/* オプションPMS */}
		<Route path={PATHS.HOTEL.MANAGEMENT.ACTIVITIES.OPTIONS} index element={<ManagementActivitiesOptionsPage />} />

		{/* 収支管理 */}
		{/* 収支管理TOP */}
		<Route path={PATHS.HOTEL.MANAGEMENT.SALES.TOP} index element={<ManagementSalesTopPage />} />
		<Route path={PATHS.HOTEL.MANAGEMENT.SALES.RECEIPTS} index element={<ManagementSalesReceiptsPage />} />

		{/* 返金処理一覧TOP */}
		<Route path={PATHS.HOTEL.MANAGEMENT.REFUND_REQUEST.TOP} index element={<ManagementRefundRequestTopPage />} />

		{/* EC管理 */}
		{/* EC TOP */}
		<Route path={PATHS.HOTEL.MANAGEMENT.EC_SALES.TOP} index element={<ManagementECSalecTopPage />} />
		{/* EC詳細 */}
		<Route path={PATHS.HOTEL.MANAGEMENT.EC_SALES.DETAIL} index element={<ManagementECReceiptDetailPage />} />

		{/* プラン */}
		{/* プラン一覧 */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.TOP} index element={<PlanListPage />} />
		{/* プラン在庫 */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.STOCK} index element={<PlanStockPage />} />
		{/* プラン在庫（廃止予定タブ用） */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.STOCK_DEPRECATED} index element={<PlanStockDeprecatedPage />} />
		{/* 日別料金一覧 */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.RATE_MATRIX} index element={<PlanRateMatrixPage />} />
		{/* 既存プランの編集 */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DEFAULT} index element={<PlanEditPage />} />
		<Route path={PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.I18N} index element={<PlanI18nEditPage />} />
		{/* 新規プラン編集 */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.EDIT.NEW.PLAN.STANDARD} index element={<NewPlanEditPageDefault />} />
		{/* 既存日帰りプラン編集 */}
		<Route
			path={PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT}
			index
			element={<ExistingDayTripPlanEditPage />}
		/>
		<Route
			path={PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.I18N}
			index
			element={<ExistingDayTripPlanI18nEditPage />}
		/>
		{/* 新規日帰りプラン編集 */}
		<Route path={PATHS.HOTEL.ITEMS.PLAN.EDIT.NEW.PLAN.DAYTRIP} index element={<NewDayTripPlanEditPageDefault />} />

		{/* 部屋 */}
		{/* 部屋一覧 */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.TOP} index element={<RoomListPage />} />
		{/* 部屋在庫 */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.STOCK} index element={<RoomStockPage />} />
		{/* 部屋在庫（廃止予定タブ用） */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.STOCK_DEPRECATED} index element={<RoomStockDeprecatedPage />} />
		{/* 部屋料金設定（料金ランク。サイコンではなくCHILLNNで部屋の料金を管理している場合に使用する画面） */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.PRICE_RANK} index element={<RoomPriceRankPage />} />
		{/* 部屋料金設定（廃止予定タブ用） */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.PRICE_RANK_DEPRECATED} index element={<RoomPriceRankDeprecatedPage />} />
		{/* 既存の部屋編集 */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT} index element={<RoomEditPageDefault />} />
		<Route path={PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.I18N} index element={<RoomEditPageI18n />} />
		<Route path={PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DUMMY} index element={<DummyRoomEditPage />} />
		{/* 新規部屋編集 */}
		<Route path={PATHS.HOTEL.ITEMS.ROOM.EDIT.NEW.ROOM.DEFAULT} index element={<NewRoomDefaultEditPage />} />
		<Route path={PATHS.HOTEL.ITEMS.ROOM.EDIT.NEW.DUMMY.DEFAULT} index element={<NewDummyRoomEditPage />} />

		{/* オプション */}
		{/* オプション一覧 */}
		<Route path={PATHS.HOTEL.ITEMS.OPTION.TOP} index element={<OptionListPage />} />
		{/* オプション在庫 */}
		<Route path={PATHS.HOTEL.ITEMS.OPTION.STOCK} index element={<OptionStockPage />} />
		{/* オプション在庫（廃止予定タブ用） */}
		<Route path={PATHS.HOTEL.ITEMS.OPTION.STOCK_DEPRECATED} index element={<OptionStockDeprecatedPage />} />
		{/* 既存のオプション編集 */}
		<Route path={PATHS.HOTEL.ITEMS.OPTION.EDIT.NEW.OPTION.DEFAULT} index element={<NewOptionEditPageDefault />} />
		<Route path={PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.DEFAULT} index element={<OptionEditPageDefault />} />
		<Route path={PATHS.HOTEL.ITEMS.OPTION.EDIT.OPTIONS_ID.I18N} index element={<OptionEditPageI18n />} />

		{/* ディスカウント */}
		{/* ディスカウント一覧 */}
		<Route path={PATHS.HOTEL.ITEMS.DISCOUNT.TOP} index element={<DiscountListPage />} />
		{/* ディスカウント作成 */}
		<Route path={PATHS.HOTEL.ITEMS.DISCOUNT.NEW} index element={<DiscountNewPage />} />
		{/* ディスカウント編集 */}
		<Route path={PATHS.HOTEL.ITEMS.DISCOUNT.EDIT} index element={<DiscountEditPage />} />
		{/* ディスカウント複製 */}
		<Route path={PATHS.HOTEL.ITEMS.DISCOUNT.DUPLICATE} index element={<DiscountDuplicatePage />} />

		{/* ホテル設定 施設情報 */}
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.EDIT.DEFAULT} index element={<HotelInfoEditDefaultPage />} />
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.EDIT.I18N} index element={<HotelInfoEditI18nPage />} />
		{/* ホテル設定 */}
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.TOP} index element={<HotelPolicyEditPageDefault />} />
		{/* ホテル設定 */}
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.HOTEL_POLICY.I18N} index element={<HotelPolicyEditPageI18n />} />
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.EMAIL} index element={<HotelSettingsEmailPage />} />
		{/* ホテル設定 基本メール設定 */}
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.TOP} index element={<CustomMailSettingDefaultPage />} />
		<Route path={PATHS.HOTEL.HOTEL_SETTINGS.MAIL_SETTINGS.I18N} index element={<CustomMailSettingI18nPage />} />

		{/* 予約ページの編集 */}
		{/* プレーン */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.BASE} index element={<DesignPlainDefaultPage />} />
		{/* マガジン */}
		{/* マガジン リスト */}
		{/* マガジン リスト プラン */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.PLAN} index element={<DesignMagazinePlanListPage />} />
		{/* マガジン リスト 部屋 */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.ROOM} index element={<DesignMagazineRoomListPage />} />
		{/* マガジン リスト ホテル */}
		<Route
			path={PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.LIST.HOTEL}
			index
			element={<DesignMagazineAboutHotelListPage />}
		/>
		{/* マガジン 設定 */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.MAGAZINE.SETTING} element={<DesignMagazineSettingPage />} />

		{/* HPB（ホームページビルダー） */}
		<Route path={PATHS.HOTEL.HPB.LIST} index element={<DesignHPBListPage />} />

		{/* スナック */}
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST} index element={<DesignSnackListPage />} />
		<Route path={PATHS.HOTEL.RESERVATION_PAGE.SNACK.SETTING} index element={<DesignSnackSettingPage />} />

		{/* 設定 */}
		<Route path={PATHS.SETTINGS.PAYMENT_CREDIT} index element={<SettingsPaymentCreditPage />} />
		<Route path={PATHS.SETTINGS.PAYMENT_DEPOSIT_ACCOUNT} index element={<SettingsPaymentDepositAccountPage />} />
		{/* 料金プラン設定 */}
		<Route path={PATHS.SETTINGS.BILLING} index element={<SettingsBillingPage />} />
		{/* サイトコントローラ設定 */}
		<Route path={PATHS.SETTINGS.SITE_CONTROLLER} index element={<SettingsSiteControllerPage />} />
		{/* セキュリティ設定 */}
		<Route path={PATHS.SETTINGS.SECURITY} index element={<SettingsSecurityPage />} />
		{/* 埋め込みウィジェット設定 */}
		<Route path={PATHS.SETTINGS.EXTERNAL_CONNECTION.SITE_EMBED} index element={<SettingsExternalConnectionSiteEmbedPage />} />
		<Route
			path={PATHS.SETTINGS.EXTERNAL_CONNECTION.GOOGLE_FREE_BOOKING_LINKS.DEFAULT}
			index
			element={<SettingsExternalConnectionGoogleFreeBookingLinksPage />}
		/>
		<Route
			path={PATHS.SETTINGS.EXTERNAL_CONNECTION.GOOGLE_FREE_BOOKING_LINKS.I18N}
			index
			element={<SettingsExternalConnectionGoogleFreeBookingLinksI18nPage />}
		/>

		{/* FAQ */}
		<Route path={PATHS.FAQ} index element={<FAQPage />} />
		<Route path={PATHS.FAQ_DETAIL} index element={<FAQDetailPage />} />

		{/* 問い合わせ */}
		{/* 問い合わせ（一覧） */}
		<Route path={PATHS.HOTEL.CONTACT.TOP} index element={<ContactTopPage />} />
		{/* 問い合わせ（新規問い合わせ作成） */}
		<Route path={PATHS.HOTEL.CONTACT.NEW} index element={<ContactNewPage />} />
		{/* 問い合わせ（チャットぽいルーム。過去の送受信メッセージと新規送信ができる） */}
		<Route path={PATHS.HOTEL.CONTACT.CHAT_ROOM} element={<ContactChatRoomPage />} index />

		{/* 解約 */}
		<Route path={PATHS.CANCELLATION} index element={<CancellationPage />} />

		{/* 販売前最終チェック表 */}
		<Route path={PATHS.HOTEL.START_GUIDE_CHECKLIST} index element={<StartGuideChecklistPage />} />
	</Route>
);
